@if (isModalActive && initialized) {
<div class="modal-header">
    <h3 class="modal-title fkm-modal-title" id="modal-title">{{texts.produktionsomrade}} {{produktionsomrade.namn}}</h3>
    <button type="button" class="btn-close" (click)="dismissModal()"></button>
</div>
}
@if (initialized) {
<form id="poForm" [formGroup]="form">
    <div class="row mb-5">
        <div class="col-6">
            <rask-header size="3" undeline>{{texts.brytgransTitel}}</rask-header>
            <div class="col-12">
                <rask-input-number [label]="texts.tallNedre" formControlName="tallNedre" unit="mm"
                    [rule]="validation.tallNedre"></rask-input-number>
                <rask-input-number [label]="texts.tallOvre" formControlName="tallOvre" unit="mm"
                    [rule]="validation.tallOvre"></rask-input-number>
            </div>
            <div class="col-12">
                <rask-input-number [label]="texts.granNedre" formControlName="granNedre" unit="mm"
                    [rule]="validation.granNedre"></rask-input-number>
                <rask-input-number [label]="texts.granOvre" formControlName="granOvre" unit="mm"
                    [rule]="validation.granOvre"></rask-input-number>
            </div>
            <div class="col-12">
                <rask-checkbox
                    [label]="texts.beraknaVinteravstand"
                    formControlName="beraknaVinteravstand">
                </rask-checkbox>
            </div>
        </div>
        <div class="col-6">
            <rask-header size="3" undeline>{{texts.voUppgifterTitel}}</rask-header>
            <rask-input class="col-7" [label]="texts.internnummer" formControlName="internnummer"
                [rule]="validation.internnummer"></rask-input>
            <rask-input class="col-7" [label]="texts.namn" formControlName="violNamn"
                [rule]="validation.namn"></rask-input>
            <rask-input class="col-7" [label]="texts.adress1" formControlName="adress1"
                [rule]="validation.adress1"></rask-input>
            <rask-input class="col-7" [label]="texts.adress2" formControlName="adress2"
                [rule]="validation.adress2"></rask-input>
            <rask-input class="col-7" [label]="texts.postnummer" formControlName="postnummer"
                [rule]="validation.postnummer"></rask-input>
            <rask-input class="col-7" [label]="texts.postadress" formControlName="postadress"
                [rule]="validation.postadress"></rask-input>
            <rask-input class="col-7" [label]="texts.mobilnummer" formControlName="mobilnummer"
                [rule]="validation.mobilnummer"></rask-input>
            <rask-input class="col-7" [label]="texts.telefonnummer" formControlName="telefonnummer"
                [rule]="validation.telefonnummer"></rask-input>
            <rask-selector class="col-7" [values]="prislistor" [addModelValueWhenMissing]="getCurrentPrislista"
                [viewFormatter]="prislistaViewFormatter" [formatter]="prislistaFormatter" label="Terminalprislista"
                formControlName="terminalprislistaId"></rask-selector>
        </div>
        <div class="col-12 align-right mt-3">
            <rask-save-button form="poForm" (click)="save()" [disabled]="!canSave"></rask-save-button>
            <rask-button color="secondary" (click)="raknaOmDirektutbyte()" [disabled]="!isEditableRole">{{
                texts.raknaOmDirektutbyte }}</rask-button>
            <rask-button color="secondary" (click)="dismissModal()">{{ 'DEFAULT_BUTTON_LABEL_AVBRYT' | translate
                }}</rask-button>
        </div>
    </div>
</form>
}